import * as React from "react";

const CartIcon: React.FC = () => {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width="48.000000pt"
            height="37.000000pt"
            viewBox="0 0 48.000000 37.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g transform="translate(0.000000,37.000000) scale(0.100000,-0.100000)" fill="#00539b" stroke="none">
                <path
                    d="M0 360 c0 -5 15 -10 34 -10 l34 0 62 -157 c34 -87 65 -165 69 -173
12 -22 35 -18 46 7 8 19 18 23 57 23 34 0 48 -4 48 -14 0 -7 7 -19 16 -26 12
-11 18 -10 31 3 9 8 13 22 10 31 -5 12 -27 16 -103 18 -87 3 -98 5 -112 25
l-14 23 120 0 c84 0 122 4 129 13 15 19 54 167 48 177 -4 6 -82 10 -188 10
l-182 0 -17 30 c-14 24 -24 30 -53 30 -19 0 -35 -4 -35 -10z m177 -150 c28
-72 29 -80 13 -80 -11 0 -22 11 -28 28 -5 15 -19 51 -31 80 -19 48 -19 52 -3
52 12 0 26 -23 49 -80z m31 53 c5 -16 19 -52 31 -80 19 -49 19 -53 3 -53 -12
0 -26 23 -49 80 -28 72 -29 80 -13 80 11 0 22 -11 28 -27z m71 -50 c17 -42 29
-78 26 -81 -13 -13 -34 13 -58 75 -31 79 -32 83 -13 83 8 0 27 -33 45 -77z
m46 14 c38 -92 39 -99 20 -95 -10 2 -27 27 -40 61 -38 92 -39 99 -20 95 10 -2
27 -27 40 -61z m58 -10 c15 -41 27 -77 27 -80 0 -15 -28 -6 -35 11 -50 124
-55 142 -37 142 13 0 25 -20 45 -73z m41 28 c13 -32 15 -49 7 -62 -9 -16 -10
-16 -19 7 -5 14 -17 42 -25 63 -15 35 -15 37 2 37 12 0 24 -14 35 -45z m36 33
c0 -7 -4 -19 -9 -26 -7 -11 -10 -10 -15 3 -10 26 -7 35 9 35 8 0 15 -6 15 -12z
m-230 -248 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4
10 -10z m160 0 c0 -5 -4 -10 -10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10
-4 10 -10z"
                />
            </g>
        </svg>
    );
};

export default React.memo(CartIcon);
